import TransponderIntermediateTimesTabContent from './TransponderIntermediateTimesTabContent';

export default TransponderIntermediateTimesTabContent;